import { Serializable } from '../../../core/models/serializable';
import { BannerPositionModel } from './banner-position-model';

export class BannerPositionListViewModel
  implements Serializable<BannerPositionListViewModel>
{
  fromObject(object: any): BannerPositionListViewModel {
    Object.assign(this, object);

    return this;
  }
  toObject() {
    return {
      BannerPositions: this.bannerPositions,
      HeadBannerPositions: this.headBannerPositions,
    };
  }
  public bannerPositions: { [objectId: number]: BannerPositionModel[] };
  public headBannerPositions: number[];
}
